import { useSelector } from "react-redux";
import DeleteAccount from "./DeleteAccount";
import PersonalInfo from "./PersonalInfo";
import TwoFactorAuthSetting from "./TwoFactorAuthSetting";
import { RootState } from "../../redux/store";
import DeleteConfirmationModal from "./DeleteConfirmationModal";
import { useGetUserInfo } from "./api";
import { useEffect } from "react";
import { toast } from "react-toastify";
import { ClipLoader } from "react-spinners";
import { useLocation } from "react-router";

export default function Profile() {
  const { isModalOpen } = useSelector(
    (state: RootState) => state.deleteConfirmModal
  );
  const location = useLocation();

  const { data: user, isLoading, error, refetch } = useGetUserInfo();

  useEffect(() => {
    if (error) {
      toast.error(
        error instanceof Error
          ? error.message
          : "Unexpected server error. Please try again later."
      );
    }
  }, [error]);

  useEffect(() => {
    refetch();
  }, [location.key, refetch]);

  if (isLoading)
    return (
      <div className='flex justify-center items-center h-screen'>
        <ClipLoader
          color='#0F4988'
          loading={isLoading}
          // cssOverride={override}
          size={window.innerWidth < 640 ? 70 : 150}
          aria-label='Loading Spinner'
          data-testid='loader'
        />
      </div>
    );

  return (
    <div className='bg-[#F5F5F5] w-full flex flex-col items-center justify-start mt-20'>
      <PersonalInfo user={user} />
      <TwoFactorAuthSetting currentState={user?.is_2fa_enabled} />
      <DeleteAccount />
      {isModalOpen && <DeleteConfirmationModal />}
    </div>
  );
}
